module.exports = __webpack_public_path__ + "static/media/icon_linux.baecfbf8.svg";